// SPDX-License-Identifier: FSL-1.1-Apache-2.0
/**
 * @module AnalyticsDashboard
 * @package @geenius/analytics/solidjs
 * @description Publishes the SolidJS analytics dashboard through the component
 * catalog while delegating rendering to the page implementation.
 */

import type { Component } from "solid-js";
import {
  AnalyticsDashboardPage,
  type AnalyticsDashboardPageProps,
} from "../pages/AnalyticsDashboardPage";

/** Props accepted by the public SolidJS analytics dashboard component. */
export type AnalyticsDashboardProps = AnalyticsDashboardPageProps;

/**
 * Renders the canonical SolidJS analytics dashboard as a component export.
 *
 * @param props Dashboard data, realtime state, and page composition options.
 * @returns The SolidJS analytics dashboard surface.
 */
export const AnalyticsDashboard: Component<AnalyticsDashboardProps> = (
  props,
) => <AnalyticsDashboardPage {...props} />;
